import { render } from "./HomepageIhecs.vue?vue&type=template&id=6508ad5c&scoped=true"
import script from "./HomepageIhecs.vue?vue&type=script&lang=js"
export * from "./HomepageIhecs.vue?vue&type=script&lang=js"

import "./HomepageIhecs.vue?vue&type=style&index=0&id=6508ad5c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6508ad5c"]])

export default __exports__